import React from 'react';
import { Link } from 'react-router-dom';
import Signedin from './Signedin';
import Signedout from './Signedout';
import { connect } from 'react-redux';

const Navbar =  (props) => {
    const { auth, profile } = props;

    const links = auth.uid ? <Signedin  profile = {profile} /> : <Signedout />;
   return(
       <nav className="nav-wrapper blue darken-3">
           <div className="container">
              <Link to = '/' className = "brand-logo">Houseparty</Link>
              { links }
           </div>
       </nav>
   )
}

const mapStateToProps = (state) => {
    console.log(state);
    return{
       auth: state.firebase.auth,
       profile: state.firebase.profile
    }
}

export default connect(mapStateToProps)(Navbar);



